import React, { useEffect} from 'react';
import Layout from 'components/Layout';
import CouponSlider from 'components/CouponSlider';
import CouponService from 'services/Coupon/service';
import { main_links } from 'config';

import './style.scss';

const Metro = () => {
    const [publicCoupons, setPublicCoupons] = React.useState([]);


    useEffect(() => {
        Promise.all([CouponService.getListPublic()]).then(coupons=>{
            if(coupons && coupons[0].payload) setPublicCoupons(coupons[0].payload);
        });
    }, []);

    const maiorLinesMsg =(coupons)=>{
      

        let couponsLines=[];
        //count lines+limite+priceMaterial
        coupons.forEach(coupon => {
            let lines=0;
            if(coupon.nivelMaterial==true){
                lines=lines+3;
            }
            if(coupon.cantCupDisponiblesLH!=null){
                lines=lines+2;
            }
            lines=lines+coupon.messages.message4.length;
            couponsLines.push(lines);
            
        });
        //maior lines
        var maxLines=Math.max(...couponsLines)
       

        return maxLines;
       
        
        
    };


    let couponContent = "";
    if(publicCoupons.length > 0) couponContent = <CouponSlider coupons={publicCoupons} toshow={6} toscroll={3} hasCart={false}
         maiorLinesMsg={maiorLinesMsg(publicCoupons)}
    />;

    return (
        <div className="homepage">
            <Layout>
                <section className="most-used">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <p className="text-center mt-4">
                                    <strong>Los más usados:</strong>
                                    <br/>Preferidos por nuestros clientes.
                                </p>
                            </div>
                            <div className="col-12">
                                {couponContent}
                            </div>
                        </div>
                    </div>
                </section>
                <section className="buttons pb-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <p className="text-center mt-5">Bienvenido (a)<br/>Para disfrutar de los cupones te<br/>invitamos a <strong>registrarte</strong>:</p>
                            </div>
                            <div className="col-12 col-md-6 text-center text-md-right">
                                <p className="mb-1"><a href={main_links.login} className="btn">Iniciar sesión</a></p>
                            </div>
                            <div className="col-12 col-md-6 text-center text-md-left">
                                <p className="mb-1"><a href={main_links.register} className="btn">Registrarse</a></p>
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
            
        </div>
    )
};

export default Metro;
